import { Component, h } from 'preact';

class TcrPwaPrompt extends Component
{
    constructor(props)
    {
        super(props);

        this.onUpdate = this.onUpdate.bind(this);

        this.state = {
            visible: false,
            state: '',
            title: '',
            icon: '',
        };

        if (window.pwaSupported && !window.pwaDismissed && window.trcloud.pwa && window.trcloud.pwa['prompt-web-install'])
        {
            this.state.visible = true;
            this.state.title = window.trcloud.pwa.title;
            this.state.icon = window.trcloud.pwa.icon;
            this.state.color = window.trcloud.pwa.theme_color_light;

            window.pwaOnUpdate(this.onUpdate);
        }
    }

    onUpdate()
    {
        let state = '';
        if (window.pwaSupported && !window.pwaDismissed && window.pwaInstallPrompt)
        {
            state = 'supported';
        }
        this.setState({state});
    }

    render()
    {
        if (!this.state.visible) return;

        return (
            <div class="redvery-pwa-prompt" data-state={this.state.state}>
                <div class="redvery-pwa-icon" style={{ backgroundImage: `url("${this.state.icon}")` }}></div>
                <div class="redvery-pwa-title">{this.state.title}</div>
                <div class="redvery-pwa-line"></div>
                <div class="redvery-pwa-info">
                    {this.state.title} gibt's auch als App.
                </div>
                <div class="redvery-pwa-dismiss" onClick={window.pwaDismiss}></div>
                <div onClick={window.pwaInstall} class="redvery-pwa-install" style={{backgroundColor: this.state.color}}>
                    Jetzt installieren
                </div>
            </div>
        );
    }
}

export { TcrPwaPrompt };